import React from 'react';
import Loadable from 'react-loadable';
import { Loading } from '../../../components';

const routes = [
  {
    path: '/',
    exact: true,
    component: Loadable({
      loader: () => import(/* webpackChunkName:'loading' */ '../../../pages/WelfareIndex'),
      loading() {
        return <Loading/>;
      },
    }),
  },
  {
    path: '/welfareIndex',
    exact: true,
    component: Loadable({
      loader: () => import(/* webpackChunkName:'loading' */ '../../../pages/WelfareIndex'),
      loading() {
        return <Loading/>;
      },
    }),
  },
  {
    path: '/rules',
    exact: true,
    component: Loadable({
      loader: () => import(/* webpackChunkName:'loading' */ '../../../pages/Rules'),
      loading() {
        return <Loading/>;
      },
    }),
  },
  {
    path: '/incomeRecord',
    exact: true,
    component: Loadable({
      loader: () => import(/* webpackChunkName:'loading' */ '../../../pages/IncomeRecord'),
      loading() {
        return <Loading/>;
      },
    }),
  },
  {
    path: '/withDraw',
    exact: true,
    component: Loadable({
      loader: () => import(/* webpackChunkName:'loading' */ '../../../pages/Withdraw'),
      loading() {
        return <Loading/>;
      },
    }),
  },
  {
    path: '/withdrawRecord',
    exact: true,
    component: Loadable({
      loader: () => import(/* webpackChunkName:'loading' */ '../../../pages/WithdrawRecord'),
      loading() {
        return <Loading/>;
      },
    }),
  },
  {
    path: '/exchangeRecord',
    exact: true,
    component: Loadable({
      loader: () => import(/* webpackChunkName:'loading' */ '../../../pages/ExchangeRecord'),
      loading() {
        return <Loading/>;
      },
    }),
  },
  {
    path: '/exchange',
    exact: true,
    component: Loadable({
      loader: () => import(/* webpackChunkName:'loading' */ '../../../pages/Exchange'),
      loading() {
        return <Loading/>;
      },
    }),
  },
  // {
  //   path: '/withdrawQb',
  //   exact: true,
  //   component: Loadable({
  //     loader: () => import(/* webpackChunkName:'loading' */ '../../../pages/Withdraw/qb'),
  //     loading() {
  //       return <Loading/>;
  //     },
  //   }),
  // },
];

export default routes;

